<template>
<header class="clearfix">
    <!-- <h1 class="header_title float_left"><span class="numtitle">{{chapterNumber}}.</span>{{contents.title}}</h1> -->
    <h1 class="header_title float_left">{{contents.chapterTitle}}</h1>
    <p class="studytitle float_right">{{contents.title}}</p>
</header>

</template>
<script>
export default {
    props : ['contents','chapterNumber'],
    data(){
        return{

        }
    },
    methods:{
    },
    mounted(){
    }
}
</script>